import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import AssistLifeStage from "./pages/AssistLifeStage";
import AssistTravelTransport from "./pages/AssistTravelTransport";
import HomeModification from "./pages/HomeModification";
import DailyLifeTasks from "./pages/DailyLifeTasks";
import LifeSkills from "./pages/LifeSkills";
import EarlyChildhoodSupports from "./pages/EarlyChildhoodSupports";
import HouseholdTasks from "./pages/HouseholdTasks";
import ParticipateCommunity from "./pages/ParticipateCommunity";
import PlanManagement from "./pages/PlanManagement";
import GroupActivities from "./pages/GroupActivities";
import Accommodation from "./pages/Accommodation";
import Referrels from "./pages/Referrels";
import Feedback from "./pages/Feedback";
import JoinOurTeam from "./pages/JoinOurTeam";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/Common/ScrollToTop";

const AppRouter = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/assist-life-stage" element={<AssistLifeStage />} />
        <Route path="/assist-travel-transport" element={<AssistTravelTransport />} />
        <Route
          path="/home-modification"
          element={<HomeModification />}
        />
        <Route path="/daily-life-tasks" element={<DailyLifeTasks />} />
        <Route
          path="/life-skills"
          element={<LifeSkills />}
        />
        <Route path="/early-childhood-supports" element={<EarlyChildhoodSupports />} />
        <Route
          path="/participate-community"
          element={<ParticipateCommunity />}
        />
        <Route
          path="/plan-management"
          element={<PlanManagement />}
        />
        <Route
          path="/group-activities"
          element={<GroupActivities />}
        />
        <Route path="/household-tasks" element={<HouseholdTasks />} />
        <Route path="/accommodation" element={<Accommodation />} />
        <Route path="/referrels" element={<Referrels />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/join-our-team" element={<JoinOurTeam />} />
        {/* Catch-all route for undefined paths */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRouter;
